import api from './api';
import type { User, UserRole } from '../types';

export interface CreateUserData {
  name: string;
  email: string;
  role: UserRole;
}

export interface UpdateUserData {
  name?: string;
  email?: string;
  role?: UserRole;
}

export const userService = {
  getAll: async (): Promise<User[]> => {
    const response = await api.get<{ users: User[] }>('/users');
    return response.data.users ?? [];
  },

  create: async (data: CreateUserData): Promise<User> => {
    const response = await api.post<User>('/users', data);
    return response.data;
  },

  update: async (id: string, data: UpdateUserData): Promise<User> => {
    const response = await api.patch<User>(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },
};
